import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '../../../core/notifications/notification.service';
import { MarkdownService } from '../../../markdown/markdown.service';
import { LightPostModel } from '../../../shared/data/models/light-post.model';
import { EchoContentModel } from '../../../shared/data/models/echo-content.model';
import { PostBodyModel } from '../../../shared/data/models/post-body.model';
import { NewPostMutationInput } from '../../../shared/data/inputs/new-post-mutation.input';

@Component({
  selector: 'anms-echo-dialog',
  templateUrl: './echo-dialog.component.html',
  styleUrls: ['./echo-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class EchoDialogComponent implements OnInit {
  echoFormGroup: FormGroup;

  repostOriginalBody: string;
  repostRepostBody: string;

  constructor(
    public dialogRef: MatDialogRef<EchoDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      post: LightPostModel;
      echoContent: EchoContentModel;
    },
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private markdownService: MarkdownService
  ) {
    if (data?.post?.echoContent?.originalPost?.body) {
      this.repostOriginalBody = markdownService.convertMarkDownForDisplay(
        data?.post?.echoContent?.originalPost?.body
      );
    } else {
      this.repostRepostBody = markdownService.convertMarkDownForDisplay(
        this.parseBody(data?.post?.body).body
      );
    }

    this.echoFormGroup = this.creatEchoForm();
  }

  ngOnInit(): void {}

  parseBody(body): PostBodyModel {
    let data: any;
    try {
      data = JSON.parse(body);
    } catch (e) {
      data = {
        body
      };
    }

    return data;
  }

  createEcho(): void {
    if (this.echoFormGroup.invalid) {
      this.echoFormGroup.markAllAsTouched();
      this.notificationService.error(
        'Make sure your form does have any errors'
      );
      return;
    }
    const formData: {
      echo?: string;
    } = this.echoFormGroup.getRawValue();

    const content: NewPostMutationInput = {
      body: this.markdownService.convert(formData.echo) || '',
      postType: 'ECHO',
      echoData: {
        postID:
          this.data?.post?.echoContent?.originalPost?.Id || this.data?.post?.Id
      }
    };
    this.dialogRef.close(content);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private creatEchoForm(): FormGroup {
    return this.formBuilder.group({
      echo: ['', Validators.required]
    });
  }
}
